var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('i',{staticClass:"ion ion-information-circle-outline",attrs:{"id":_vm.target}}),_c('b-popover',{attrs:{"target":_vm.target,"triggers":"hover","placement":"bottom"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }